// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<ul class=\"brec-animated-ellipsis brec-animated-ellipsis--disabled-button\">\n  <li></li><li></li><li></li>\n</ul>\n";
},"useData":true});
